import { useEffect, useState } from "react";
import { formatValueToMonetary } from "../../../../utils/formatter";
import { Link } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Box } from "../../../box";
import { listInstallmentPix } from "../../../../services/pix.service";
import { PageHeader } from "../../../page-header";

export function PixContractsList() {
  const [contracts, setContracts] = useState([]);
  const [expandedContractId, setExpandedContractId] = useState(null);
  const [loading, setLoading] = useState(false);

  async function handleListInstallments() {
    const response = await listInstallmentPix();
    return response.data;
  }

  const loadContracts = async () => {
    try {
      setLoading(true);
      const response = await handleListInstallments();
      setContracts(Array.isArray(response.data) ? response.data : []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadContracts();
  }, []);

  const toggleExpand = (contractId) => {
    setExpandedContractId((prev) =>
      prev === contractId ? null : contractId
    );
  };

  function translateStatus(status) {
    const statusMap = {
      pending: 'Pendente',
      paid: 'Pago',
      failed: 'Falhou',
      late: 'Em atraso',
    };

    return statusMap[status] || status;
  }


  if (loading) {
    return (
      <p className="text-sm text-gray-500 mt-6">
        Carregando contratos...
      </p>
    );
  }

  if (!contracts.length) {
    return (
      <p className="text-sm text-gray-500 mt-6">
        Nenhum contrato encontrado.
      </p>
    );
  }

  return (
    <div className="transferencia-ted">
      <div className="transferencia-ted-container col-md-10">
        {/* HEADER */}
        <div className="mt-4 mb-3">
          <PageHeader title="Pix Parcelado" pages={[{ name: 'Pix Parcelado', link: "/pagina-pix-parcelado" }]} />
        </div>
        <main className="max-w-3xl mx-auto px-4 py-6 space-y-6">

          <Box>
            <div>
              <h4 className="font-semibold mb-4">
                Meus Pix Parcelados
              </h4>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                  overflowY: "auto",
                  maxHeight: "60vh",
                  paddingRight: "4px",
                }}
              >

                {contracts.map((contract) => {
                  const isExpanded = expandedContractId === contract.id;

                  return (
                    <div
                      key={contract.id}
                    >
                      <div
                        onClick={() => toggleExpand(contract.id)}
                        style={{
                          padding: "16px",
                          borderRadius: "12px",
                          border: isExpanded
                            ? "2px solid var(--notification-menu-primary-button-background)"
                            : "1px solid #e5e7eb",
                          backgroundColor: isExpanded ? "#eff6ff" : "#ffffff",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          boxShadow: isExpanded
                            ? "0 4px 12px rgba(59, 130, 246, 0.15)"
                            : "0 1px 3px rgba(0,0,0,0.08)",
                        }}
                      >
                        {/* Header */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "12px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: 600,
                              color: "#111827",
                            }}
                          >
                            Contrato #{contract.documentNumber}
                          </span>

                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: 500,
                              padding: "4px 10px",
                              borderRadius: "9999px",
                              backgroundColor: "#e5e7eb",
                              color: "#374151",
                            }}
                          >
                            {contract.installments}x
                          </span>
                        </div>

                        {/* Total */}
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#6b7280",
                            marginBottom: "4px",
                          }}
                        >
                          Total
                        </div>

                        <div
                          style={{
                            fontSize: "20px",
                            fontWeight: 700,
                            color: "#111827",
                            letterSpacing: "-0.02em",
                          }}
                        >
                          R$ {formatValueToMonetary(contract.totalAmount)}
                        </div>
                      </div>


                      {isExpanded && (
                        <div
                          className="
      mt-2
      p-3
      border
      rounded-lg
      bg-white
      space-y-2
    "
                        >
                          <h4 style={{ color: "black" }}>
                            Parcelas
                          </h4>

                          <div
                            style={{
                              maxHeight: "350px",
                              overflowY: "auto",
                              width: "100%",
                            }}
                          >
                            <table
                              className="w-full text-xs border-collapse"
                              style={{
                                width: "100%",
                                tableLayout: "fixed",
                                color: "black",
                              }}
                            >
                              <thead>
                                <tr
                                  style={{
                                    borderBottom: "1px solid #e5e7eb",
                                  }}
                                >
                                  <th
                                    style={{
                                      width: "25%",
                                      textAlign: "center",
                                      padding: "8px",
                                    }}
                                  >
                                    Parcela
                                  </th>

                                  <th
                                    style={{
                                      width: "25%",
                                      textAlign: "left",
                                      padding: "8px",
                                    }}
                                  >
                                    Vencimento
                                  </th>

                                  <th
                                    style={{
                                      width: "25%",
                                      textAlign: "right",
                                      padding: "8px",
                                    }}
                                  >
                                    Valor
                                  </th>

                                  <th
                                    style={{
                                      width: "25%",
                                      textAlign: "right",
                                      padding: "8px",
                                    }}
                                  >
                                    Status
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {contract.pixInstallments.map((installment, index) => (
                                  <tr
                                    key={installment.id}
                                    style={{ borderBottom: "1px solid #e5e7eb" }}
                                  >
                                    <td
                                      style={{
                                        width: "25%",
                                        textAlign: "center",
                                        padding: "8px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {index + 1}ª
                                    </td>

                                    <td
                                      style={{
                                        width: "25%",
                                        padding: "8px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {new Date(installment.dueDate).toLocaleDateString("pt-BR")}
                                    </td>

                                    <td
                                      style={{
                                        width: "25%",
                                        textAlign: "right",
                                        fontWeight: 500,
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      R$ {formatValueToMonetary(installment.amount)}
                                    </td>

                                    <td
                                      style={{
                                        width: "25%",
                                        textAlign: "right",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: "inline-block",
                                          maxWidth: "100%",
                                          padding: "2px 8px",
                                          borderRadius: "9999px",
                                          fontSize: "11px",
                                          fontWeight: 500,
                                          backgroundColor:
                                            installment.status === "paid"
                                              ? "#dcfce7"
                                              : installment.status === "pending"
                                                ? "#fef9c3"
                                                : "#f3f4f6",
                                          color:
                                            installment.status === "paid"
                                              ? "#15803d"
                                              : installment.status === "pending"
                                                ? "#a16207"
                                                : "#4b5563",
                                        }}
                                      >
                                        {translateStatus(installment.status)}
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}


                    </div>
                  );
                })}
              </div>
            </div>
          </Box>
        </main>
      </div>
    </div>
  );
}
